Vue.component("contract-list",
    {
        template: "#vue-contract-list",

        data()
        {
            return {
                additionalCosts: []
            };
        },

        computed: {
            ...Vuex.mapState(
                {
                    preparedContractList: state => state.assistant.preparedContractList,
                    selectedContractType: state => state.assistant.selectedContractType,
                    currentContractType:  state => state.assistant.currentContractType,
                    assistantModuleList:  state => state.assistant.assistantModuleList,
                    upgradeNotAllowed:    state => state.assistant.upgradeNotAllowed,
                    calcContractType:     state => state.assistant.calcContractType,
                    additionalCosts:      state => state.assistant.additionalCosts,
                    contractList:         state => state.assistant.contractList,
                    pid:                  state => state.assistant.pid
                }
            ),

            ...Vuex.mapGetters(
                {
                    selectedContractId: "getSelectedContractId",
                    trans:              "getTranslation",
                    isFlexFeeItem:      "isFlexFeeItem",
                    isModuleItem:       "isModuleItem",
                    isAdditionalItem:   "isAdditionalItem"
                }
            )
        },

        methods: {
            ...Vuex.mapMutations(
                [
                    "selectContract",
                    "setAdditionalCosts"
                ]
            ),

            /**
             * Navigation between pages
             * @param direction 'next' || 'back'
             */
            navAction(direction)
            {
                this.$emit("nav-action", direction);
            },

            /**
             * Open additional costs in a modal
             * @param children
             */
            openAdditionalCostsModal(children)
            {
                this.setAdditionalCosts(children);
            },

            openSelectFlexModal(id)
            {
                this.selectContract(id);
                $("#proflexModal").modal("show");
            },

            openClassicInfoModal()
            {
                this.$root.$emit("openClassicModal");
            },

            /**
             * Check if contract change is allowed
             * @param id
             * @param contractType
             */
            checkContractSelection(id, contractType)
            {
                if (Object.keys(this.upgradeNotAllowed).length > 0 &&
                    this.pid > 0)
                {
                    if (contractType === "proflex")
                    {
                        this.openSelectFlexModal(id);
                    }
                    else if (!this.upgradeNotAllowed[contractType])
                    {
                        this.selectContractAndNext(id);
                    }
                }
                else if (contractType === "proflex")
                {
                    this.openSelectFlexModal(id);
                }
                else
                {
                    this.selectContractAndNext(id);
                }
            },

            /**
             * Select contract an go next
             * @param id
             */
            selectContractAndNext(id)
            {
                this.selectContract(id);
                this.navAction("next");
            },

            /**
             * Get module info, depend on properties.
             * @param data
             * @returns {*}
             */
            getModuleInfo(data)
            {
                if (data.variationProperties && data.variationProperties.length > 0)
                {
                    return this.variationPropertyValue(data.variationProperties);
                }
                else if (data.properties && data.properties.length > 0)
                {
                    return this.propertyValue(data);
                }
                return "";
            },

            /**
             * Gets warning triangle if selected value exceeds max
             *
             * @param data
             * @returns {*}
             */
            getModuleWarning(data)
            {
                let moduleKey = null;

                for (const property of data.properties)
                {
                    if (property.property.names && property.property.names.name === "Module")
                    {
                        moduleKey = property.texts.value;
                    }
                }

                if (moduleKey && moduleKey !== "hosting.type" && data.variationProperties)
                {
                    const moduleDetails = [];

                    for (const property of data.variationProperties)
                    {
                        if (property.property.names)
                        {
                            moduleDetails[property.property.names.name] = property.values.value;
                        }
                    }

                    for (const assistantModuleKey in this.assistantModuleList)
                    {
                        const assistantModule = this.assistantModuleList[assistantModuleKey];

                        if (assistantModule.module === moduleKey)
                        {
                            let itemMax = 0;

                            itemMax += parseInt(moduleDetails.max) || parseInt(moduleDetails.inclusive) || 0;

                            return assistantModule.value > itemMax;
                        }
                    }
                }

                return false;
            },

            /**
             * Get contract module benefits
             * @param properties
             * @returns {string}
             */
            variationPropertyValue(properties)
            {
                const incl = this.trans("incl");
                const max  = this.trans("max");
                const upTo = this.trans("upTo");

                const moduleDetails = [];

                for (const property of properties)
                {
                    if (property.property.names)
                    {
                        moduleDetails[property.property.names.name] = property.values.value;
                    }
                }

                if (!moduleDetails.inclusive && moduleDetails.max)
                {
                    return upTo + " " + moduleDetails.max;
                }

                if (moduleDetails.inclusive && !moduleDetails.max)
                {
                    return incl + " " + moduleDetails.inclusive;
                }

                return incl + " " + moduleDetails.inclusive + " / " + max + " " + moduleDetails.max;
            },

            /**
             * Get module name, especially only relevant for hosting.
             * @param data
             * @returns {*}
             */
            propertyValue(data)
            {
                for (const property in data.properties)
                {
                    if (data.properties.hasOwnProperty(property) &&
                        data.properties[property].property.names.name === "Module" &&
                        data.properties[property].texts.value === "hosting.type")
                    {
                        return data.texts.name1;
                    }
                }
                return "";
            },

            /**
             * Get module name
             * @param name
             * @returns {*}
             */
            getModuleHeader(name)
            {
                if (name.indexOf("Cloud") !== -1)
                {
                    return this.trans("hostingLocation");
                }
                return name;
            },

            /**
             * Get contract single name
             * @param name
             * @returns {*}
             */
            getContractName(name)
            {
                return name.replace("plentymarkets", "").replace(" ", "");
            },

            /**
             * Get contract price as header
             * @param item
             * @returns {string}
             */
            getContractOfferPrice(item)
            {
                if (item.data.texts.lang === "en")
                {
                    return item.data.price.currency.name + " " + item.data.price.priceNet;
                }
                return item.data.price.priceNet + " " + item.data.price.currency.name;
            },

            /**
             * Return number of Object properties
             *
             * @param fee
             * @returns {boolean}
             */
            hasMultipleFees(fee)
            {
                return Object.keys(fee).length > 1;
            },

            /**
             * Gets fee value for last object entry
             *
             * @param fee
             * @returns {*}
             */
            getMinimumFee(fee)
            {
                const keys = Object.keys(fee);

                return fee[keys[keys.length - 1]];
            },

            /**
             * Filter if is a module item
             * @param module
             * @returns {*}
             */
            isModuleItemFilter(module)
            {
                return !this.isFlexFeeItem(module.$key) && !this.isAdditionalItem(module.$value);
            },

            /**
             * @param module
             */
            showModuleInCard(module)
            {
                return this.isModuleItemFilter(module) &&
                    module.$value.data.texts &&
                    module.$value.data.texts.name2 &&
                    module.$value.data.texts.name2.indexOf("Cloud") === -1;
            }
        }
    });
